import _ from "lodash";
import { IconSymbols } from "../../../../../../../../components/ui/Icon";
import { AutocompleteOption } from "../../../../../../../../components/ui/_forms/Autocomplete/AutocompleteOption";
import { FORM_COL, REMOVE_UNSAFE_CHARACTERS } from "../../../../../../../../constants";
import { IMultiSelectorModel } from "../../../../../../../../core/forms/controls/multiSelector/IMultiSelectorModel";
import { INIT_MULTISELECTOR } from "../../../../../../../../core/forms/controls/multiSelector/MultiSelector_model";
import { generateFormFieldsFromJson } from "../../../../../../../../core/forms/helpers/FormFieldMappers";
import { filterOutExistingTagVals } from "../../../../../../../../core/grids/GridHelpers";
import I18n from "../../../../../../../../core/localization/I18n";
import { TagsApi } from "../../../../../../../../services/api/v2/tags/Tags.api";

export const getActionTagFormFields = (
  tagsProvider: TagsApi,
  organisationId: number,
  projectId: number,
  action: FP.Entities.IAction
) => {
  const removeTag = async (tag: FP.Entities.ITag) => {
    let res = await tagsProvider.removeActionTagAssoc(organisationId, projectId, tag.id, action.id);
    if (!res) return;
  };

  const addTag = async (tag: FP.Entities.ITag) => {
    let res = await tagsProvider.addActionTagAssoc(organisationId, projectId, action.id, tag);
    if (!res) return;
  };

  const addNewTag = async (tagName: string) => {
    const tag: FP.Entities.ITag = {
      id: 0,
      text: tagName
    };

    await addTag(tag);
  };

  const tags: Partial<IMultiSelectorModel> = {
    ...INIT_MULTISELECTOR,
    key: "tags",
    placeholder: I18n.t("placeholders.searchOrCreateTags"),
    optionElement: (
      <AutocompleteOption key={"e"} className={"autocomplete__chip"} label={(e: FP.Entities.ITag) => e.text} />
    ),
    onItemSelected: e => addTag(e),
    onFocus: async function () {
      const self: IMultiSelectorModel = this;

      const res = await tagsProvider.getAllAsync(organisationId);

      if (res?.payload) {
        const currentVals = self.extractValue();
        const sortedTags = _.orderBy(res.payload, [tag => tag.text.toLowerCase()]);
        self.setOptions(filterOutExistingTagVals(currentVals, sortedTags));
      }
    },
    componentProps: {
      icon: IconSymbols.TagFilled
    },
    searchAttribute: "text",
    fieldClassName: FORM_COL.FULL_WIDTH,
    extractValue: function () {
      return this.selectedItems.map(e => REMOVE_UNSAFE_CHARACTERS(e.text));
    },
    value: action?.tags,
    isHidden: false,
    valueLabelFn: e => e?.text,
    saveOnEnterFn: e => addNewTag(e.target.value),
    removeItemFn: (e, i) => removeTag(e),
    isTagSelector: true,
    allowFreeText: true,
    isNewFn: e => e.id === 0,
    noResultsFoundLabel: I18n.t("forms.tagsResultsNotFound"),
    searchResultHint: I18n.t("forms.tagsSearchResultHint")
  };

  const fields = [];

  fields.push(tags);
  const models = generateFormFieldsFromJson(fields);
  return models;
};
